const dataURLs = [
  `${process.env.PUBLIC_URL}/data/sports-data.json`,
  // `${process.env.PUBLIC_URL}/data/qao-districts.geo.json`,
  `${process.env.PUBLIC_URL}/data/qld_sa4s.geo.json`,
  // `${process.env.PUBLIC_URL}/data/south-east-qld-districts.geo.json`,
];

export const getCouncilData = () =>
  fetch(dataURLs[0]).then(response => response.json());

export const getQldCouncilGeo = () =>
  fetch(dataURLs[1]).then(response => response.json());

// export const getSouthEastQldCouncilGeo = () =>
//   fetch(dataURLs[2]).then(response => response.json());


// WEBPACK FOOTER //
// ./src/api/index.js